/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { REPORT_CRITICAL_PATH, ReportService } from '@gh/builder-shared';
import {
  CHECK_USAGE_NOT_USED,
  CheckUsage,
  CriticalPathRestService,
  ReportRestService,
} from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { GridLayoutService } from '@gh/core-ui-grid';
import { of$ } from '@gh/rx';
import { map$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';

import {
  CpStage,
  CriticalPathDetails,
  criticalPathDetailsFromDto,
  criticalPathDetailsToSaveDto,
} from './scheduling-cp-details.model';

@Injectable()
export class SchedulingCpDetailsBusinessService implements InitViewService {
  constructor(private gridLayouts: GridLayoutService,
              private reportRest: ReportRestService,
              private criticalPathRest: CriticalPathRestService,
              private reportService: ReportService) {
  }

  initView(): any {
    return {
      cpStagesLayout: this.gridLayouts.get('cpStages'),
      cpStageCcLayout: this.gridLayouts.get('cpStageCc'),
      cpUnusedCcLayout: this.gridLayouts.get('cpUnusedCc'),
      details: this.get(),
      reportUrl: this.reportService.generateUrl(REPORT_CRITICAL_PATH, []),
    };
  }

  get(): Observable<CriticalPathDetails> {
    return this.criticalPathRest.get().pipe(map$(criticalPathDetailsFromDto));
  }

  save(criticalPath: CriticalPathDetails): Observable<CriticalPathDetails> {
    return this.criticalPathRest.save(criticalPathDetailsToSaveDto(criticalPath)).pipe(map$(criticalPathDetailsFromDto));
  }

  checkUsage(stage: CpStage): Observable<CheckUsage> {
    return stage.isNew ? of$(CHECK_USAGE_NOT_USED) : this.criticalPathRest.checkUsage(stage);
  }
}
